import { ZodError, ZodString } from 'zod';

export interface ValidationTextResult {
  valid: boolean;
  message: string;
}

export const validateTextField = (value: string | undefined, schema: ZodString): ValidationTextResult => {
  try {
    schema.parse(value);

    return {
      valid: true,
      message: '',
    };
  } catch (error) {
    if (error instanceof ZodError) {
      const message = error.errors[0].message;

      return {
        valid: false,
        message,
      };
    }

    return {
      valid: false,
      message: '',
    };
  }
};
